export default __webpack_public_path__ + "static/media/image-49.48310b4f.png";